import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData, selectIsSubscription } from '../../../../selectors/buyPackageModal';
import { formatPoints } from '../../../../utils/string';
import { SummaryItem } from '../SummaryItem';

export const TotalAuctionPointsContainer = () => {
  const { totalAuctionPoints } = useSelector(selectBuyPackageModalData);
  const isSubscription = useSelector(selectIsSubscription);

  if (isSubscription || !totalAuctionPoints) {
    return null;
  }

  return <SummaryItem title="Придёт баллами">{formatPoints(totalAuctionPoints)}</SummaryItem>;
};
